export const VAULT = "vault";
export const FIRST_RESPONDER = "first responder";
